import { MaterialIcons } from "@expo/vector-icons";
import {
	Button,
	FormControl,
	Heading,
	Icon,
	Input,
	ScrollView,
	Stack,
} from "native-base";
import React, { useState } from "react";
import { Image, KeyboardAvoidingView, View } from "react-native";
import { useSelector } from "react-redux";
import OTPImg from "../../../assets/OTP.jpg";
import forgotPasswordPut from "../../common/forgotPasswordPut";
import ErrorToast from "../../components/ErrorToast";
import SuccessToast from "../../components/SuccessToast";
import { isWeb } from "../../utils/utils";

const PasswordReset = ({ setIsOTP, setIsLogin, memberGuid }) => {
	const [password, setPassword] = useState("");
	const [OTP, setOTP] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	const Auth = useSelector((state) => state.Login.Auth);

	const handlePasswordReset = async () => {
		try {
			setIsSubmitting(true);
			let user = await forgotPasswordPut(memberGuid, password, OTP);

			if (user.data.result) {
				setIsSubmitting(false);
				setIsLogin(true);
				SuccessToast("Password successfully reset", "Forgot Password");
			}
			// console.log("handlePasswordReset => ", user.data);
		} catch (error) {
			setIsSubmitting(false);
			console.log("handlePasswordReset Error=> ", error);
			if (error.data?.error) {
				ErrorToast(error.data.error, "Forgot Password");
			} else {
				ErrorToast(error.message, "Forgot Password");
			}
		}
	};

	return (
		<View style={{ marginTop: 50 }}>
			<KeyboardAvoidingView>
				<ScrollView>
					<Stack space={2.5}>
						<Image
							resizeMode="contain"
							source={{
								uri: isWeb() ? OTPImg : Image.resolveAssetSource(OTPImg).uri,
							}}
							style={{
								width: isWeb() ? 200 : 150,
								height: isWeb() ? 250 : 150,

								alignSelf: "center",
							}}
						/>
						<Heading size="sm" alignSelf="center">
							Please enter OTP sent to you
						</Heading>
						<View>
							<FormControl.Label>Please enter OTP</FormControl.Label>
							<Input
								InputLeftElement={
									<Icon
										as={<MaterialIcons name={"smartphone"} />}
										size={5}
										ml="2"
										color="muted.400"
									/>
								}
								placeholder={`OTP`}
								value={OTP}
								onChangeText={(text) => setOTP(text)}
								keyboardType="number-pad"
							/>
						</View>
						<View>
							<FormControl.Label>Please enter new password</FormControl.Label>
							<Input
								InputLeftElement={
									<Icon
										as={<MaterialIcons name={"lock"} />}
										size={5}
										ml="2"
										color="muted.400"
									/>
								}
								InputRightElement={
									<Icon
										onPress={() => setIsVisible(!isVisible)}
										as={
											<MaterialIcons
												name={isVisible ? "visibility" : "visibility-off"}
											/>
										}
										size={5}
										mr="2"
										color="muted.400"
									/>
								}
								secureTextEntry={isVisible ? false : true}
								placeholder={`Password`}
								value={password}
								onChangeText={(text) => setPassword(text)}
							/>
						</View>
						<View
							style={{ flexDirection: "row", justifyContent: "space-between" }}
						>
							<Button onPress={() => setIsOTP(false)} variant="subtle">
								Cancel
							</Button>
							<Button
								onPress={() => handlePasswordReset()}
								isLoading={isSubmitting}
								isLoadingText="Submitting"
								variant={isSubmitting ? "outline" : "solid"}
							>
								Submit
							</Button>
						</View>
					</Stack>
				</ScrollView>
			</KeyboardAvoidingView>
		</View>
	);
};

export default PasswordReset;
